import { render, staticRenderFns } from "./DetalhesAnaliseJustificativaDialog.vue?vue&type=template&id=bfb3f664&scoped=true"
import script from "./DetalhesAnaliseJustificativaDialog.vue?vue&type=script&lang=js"
export * from "./DetalhesAnaliseJustificativaDialog.vue?vue&type=script&lang=js"
import style0 from "./DetalhesAnaliseJustificativaDialog.vue?vue&type=style&index=0&id=bfb3f664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb3f664",
  null
  
)

export default component.exports